import { render, staticRenderFns } from "./OccurrenceReferenceDetailsModal.vue?vue&type=template&id=7a196098&scoped=true&"
import script from "./OccurrenceReferenceDetailsModal.vue?vue&type=script&lang=js&"
export * from "./OccurrenceReferenceDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceReferenceDetailsModal.vue?vue&type=style&index=0&id=7a196098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a196098",
  null
  
)

export default component.exports